import script from "./ActivitySpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitySpinner.vue?vue&type=script&setup=true&lang=js"

import "./ActivitySpinner.vue?vue&type=style&index=0&id=9565512a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9565512a"]])

export default __exports__